import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useMobileMenuReset } from "../Utils/useMobileMenuReset";
import { resetMobileMenuState } from "../Utils/active.js";

function Header() {
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useMobileMenuReset();

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const response = await fetch(
          "https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/info/site-info/"
        );
        const data = await response.json();
        setSiteInfo(data);
      } catch (error) {
        console.error("Failed to fetch site info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSiteInfo();
  }, []);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }

    const handleNavLinkClick = () => {
      resetMobileMenuState();
    };

    const navLinks = document.querySelectorAll(
      ".navbar-nav a, .navbar-nav .magnet-link"
    );
    navLinks.forEach((link) => {
      link.addEventListener("click", handleNavLinkClick);
    });

    const handleClickOutside = (event) => {
      const navbar = document.querySelector(".header-area .navbar");
      const navbarCollapse = document.querySelector(
        ".header-area .navbar-collapse"
      );

      if (navbar && navbarCollapse) {
        if (navbarCollapse.classList.contains("show")) {
          if (!navbar.contains(event.target)) {
            resetMobileMenuState();
          }
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      navLinks.forEach((link) => {
        link.removeEventListener("click", handleNavLinkClick);
      });
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const collapseEl = document.getElementById("lawgisNav");
    const toggler = document.querySelector(".header-area .navbar-toggler");
    const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;

    if (!collapseEl || !CollapseCtor) return;

    const instance = CollapseCtor.getOrCreateInstance(collapseEl, {
      toggle: false,
    });

    const onShown = () => {
      if (toggler) toggler.setAttribute("aria-expanded", "true");
    };
    const onHidden = () => {
      if (toggler) toggler.setAttribute("aria-expanded", "false");
      collapseEl.classList.remove("collapsing");
      collapseEl.style.height = "";
      collapseEl.style.overflow = "";
    };

    collapseEl.addEventListener("shown.bs.collapse", onShown);
    collapseEl.addEventListener("hidden.bs.collapse", onHidden);

    return () => {
      collapseEl.removeEventListener("shown.bs.collapse", onShown);
      collapseEl.removeEventListener("hidden.bs.collapse", onHidden);
    };
  }, []);

  const logoUrl =
    siteInfo?.logo_url && siteInfo.logo_url !== "null"
      ? siteInfo.logo_url
      : siteInfo?.icon_url || "assets/img/core-img/logo.png";
  const siteName = siteInfo?.site_name || "Օհանյան Լեգասի";

  return (
    <div>
      <div className="search-bg-overlay" id="searchOverlay"></div>
      <div className="search-form-popup">
        <h2 className="mb-4">How can I help you, Today?</h2>
        <button
          type="button"
          className="close-btn"
          id="searchClose"
          aria-label="Close"
        >
          &times;
        </button>
        <form className="search-form">
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            id="site-search"
            name="q"
          />
          <button type="submit" className="btn btn-primary">
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
          </button>
        </form>
      </div>

      <header className="header-area">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <Link
              to="/"
              className="navbar-brand d-flex align-items-center gap-2"
            >
              {loading ? (
                <div
                  className="logo-placeholder"
                  style={{
                    width: "45px",
                    height: "45px",
                    background: "#eaeaea",
                    borderRadius: "6px",
                  }}
                ></div>
              ) : (
                <img
                  src={logoUrl}
                  alt={siteName}
                  onError={(e) =>
                    (e.target.src = "assets/img/core-img/logo.png")
                  }
                  style={{
                    maxHeight: "45px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
              )}

              <span className="site-name-text">
                {loading ? "..." : siteName}
              </span>
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              aria-controls="lawgisNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={(e) => {
                const collapseEl = document.getElementById("lawgisNav");
                const CollapseCtor =
                  window.bootstrap && window.bootstrap.Collapse;
                if (!collapseEl || !CollapseCtor) return;
                const collapse = CollapseCtor.getOrCreateInstance(collapseEl, {
                  toggle: false,
                });
                const isOpen = collapseEl.classList.contains("show");
                if (isOpen) {
                  collapse.hide();
                  e.currentTarget.setAttribute("aria-expanded", "false");
                } else {
                  collapse.show();
                  e.currentTarget.setAttribute("aria-expanded", "true");
                }
              }}
            >
              <i className="ti ti-category"></i>
            </button>

            <div
              className="collapse navbar-collapse justify-content-end gap-5"
              id="lawgisNav"
            >
              <ul className="navbar-nav navbar-nav-scroll">
                <li className="lawgis-dd">
                  <Link to="/" className="magnet-link">
                    Գլխավոր
                  </Link>
                </li>
                <li className="lawgis-dd">
                  <Link to="/service" className="magnet-link">
                    Ծառայություններ
                  </Link>
                </li>
                <li className="lawgis-dd">
                  <Link to="/about-us" className="magnet-link">
                    Մեր Մասին
                  </Link>
                </li>
                <li className="lawgis-dd">
                  <Link to="/contact" className="magnet-link">
                    Կապ
                  </Link>
                </li>
              </ul>

              <div className="d-flex align-items-center">
                <Link to="/contact" className="btn btn-primary">
                  <span>
                    Խորհրդատվություն <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Խորհրդատվություն <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;
